import { render, staticRenderFns } from "./BaiDucompanySearch.vue?vue&type=template&id=5c48368c&scoped=true&"
import script from "./BaiDucompanySearch.vue?vue&type=script&lang=js&"
export * from "./BaiDucompanySearch.vue?vue&type=script&lang=js&"
import style0 from "./BaiDucompanySearch.vue?vue&type=style&index=0&id=5c48368c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c48368c",
  null
  
)

export default component.exports